import(/* webpackMode: "eager" */ "/app/typescript/apps/worker-web/src/app/[locale]/error.tsx");
